import React from 'react';

interface ButtonWithLoadingProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    loading: boolean;
    onClick?: () => void;
    className?: string;
    children: React.ReactNode;
}

/**
 * A button component that shows a loading spinner when in loading state
 * 
 * @param loading Whether the button is in loading state
 * @param onClick Function to call when button is clicked
 * @param className Additional CSS classes
 * @param children Button content
 * @param props Additional button attributes
 */
const ButtonWithLoading: React.FC<ButtonWithLoadingProps> = ({
    loading,
    onClick,
    className = '',
    children,
    disabled,
    ...props
}) => {
    return (
        <button
            onClick={onClick}
            className={`relative ${className}`}
            disabled={loading || disabled}
            {...props}
        >
            {loading && (
                <div className="absolute inset-0 flex items-center justify-center">
                    <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white"></div>
                </div>
            )}
            <span className={loading ? 'opacity-0' : ''}>{children}</span>
        </button>
    );
};

export default ButtonWithLoading; 